export const setting = {
    namespaced: true,

    state: {
        fileInfoMode: 0
    },

    mutations: {
        changeFileInfoMode(state) {
            state.fileInfoMode++;

            if (state.fileInfoMode > 3) {
                state.fileInfoMode = 0;
            }
        }
    }
}
